import en from "./en/translation.json";

const translations = { en };

export default translations;
